import { render, staticRenderFns } from "./DadosInstituicao.vue?vue&type=template&id=dc03dc88&scoped=true"
import script from "./DadosInstituicao.vue?vue&type=script&lang=js"
export * from "./DadosInstituicao.vue?vue&type=script&lang=js"
import style0 from "./DadosInstituicao.vue?vue&type=style&index=0&id=dc03dc88&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc03dc88",
  null
  
)

export default component.exports